// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"657f9da7","732":"d6dfae02","977":"966b3bee"}[chunkId] + ".chunk.js";
};